import { render, staticRenderFns } from "./FreeText.vue?vue&type=template&id=894577e8"
import script from "./FreeText.vue?vue&type=script&lang=js"
export * from "./FreeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports